import { KeyValue } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import { PdfJob } from 'src/app/models/pdf-job.interface';
dayjs.locale('de');

/**
 * Component for listing pdf jobs in the navigation bar downloads popup.
 */
@Component({
    selector: 'app-pdf-jobs',
    templateUrl: './pdf-jobs.component.html',
    styleUrls: ['./pdf-jobs.component.scss'],
    standalone: false,
})
export class PdfJobsComponent {
    private _pdfJobs: (PdfJob & { isOld?: boolean })[] = [];
    get pdfJobs(): (PdfJob & { isOld?: boolean })[] {
        return this._pdfJobs;
    }
    /**
     * The pdf jobs to show in the list.
     */
    @Input() set pdfJobs(value: (PdfJob & { isOld?: boolean })[]) {
        this._pdfJobs = value;
        this.setJobs();
    }

    /**
     * Emitted when a pdf job is deleted
     */
    @Output() delete = new EventEmitter<PdfJob & { isOld?: boolean }>();
    /**
     * Emitted when a pdf is downloaded
     */
    @Output() download = new EventEmitter<PdfJob & { isOld?: boolean }>();

    jobMap: Map<string, (PdfJob & { isOld?: boolean })[]> = new Map();

    sort = (
        a: KeyValue<string, (PdfJob & { isOld?: boolean })[]>,
        b: KeyValue<string, (PdfJob & { isOld?: boolean })[]>,
    ): number => {
        return dayjs(a.value[0].createdAt).isBefore(b.value[0].createdAt) ? 1 : -1;
    };

    setJobs(): void {
        this.jobMap = new Map();

        for (const job of this.pdfJobs) {
            let day = dayjs(job.createdAt).format('DD MMMM YYYY');
            if (dayjs().isSame(dayjs(job.createdAt), 'date')) {
                day = 'Heute';
            }

            const jobs = this.jobMap.get(day) ?? [];
            jobs.push(job);
            this.jobMap.set(
                day,
                jobs.sort((a, b) => (dayjs(a.createdAt).isBefore(b.createdAt) ? 1 : -1)),
            );
        }
    }
}
